import styled from "styled-components";
import { MEDIA_QUERY } from "../../../../entities/Common";

export const ModalProductPreviewStyled = styled.div`
  padding: 30px 20px;
  box-sizing: border-box;
  .modal-product {
    &__image {
      max-width: 500px;
      margin: 0 auto;
      margin-bottom: 40px;
      .no-image {
        position: relative;
      }
    }
    &__item {
      margin-bottom: 7.5px;
    }
    &__actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 40px;
      button {
        width: 200px;
        border-radius: 3px;
      }
    }
  }
  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    padding: 0;
  }
`;
